import { useEffect, useState } from 'react';
import { consoleLabel } from '../lib/systems.js';
import {
  cartImageForGame,
  consoleImageUrl,
  layoutForConsole,
  loadConsoleManifest,
} from '../lib/consoleAssets.js';

export function ConsoleCartPreview({ game, ejsKey }) {
  const [manifest, setManifest] = useState(null);
  const [phase, setPhase] = useState('idle');

  useEffect(() => {
    let alive = true;
    void loadConsoleManifest().then((m) => {
      if (alive) setManifest(m);
    });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    if (!game) {
      setPhase('idle');
      return;
    }
    setPhase('approach');
    const t1 = window.setTimeout(() => setPhase('insert'), 120);
    const t2 = window.setTimeout(() => setPhase('connected'), 920);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [game?.id, game?.title]);

  const key = game?._ejsKey || ejsKey;
  const layout = layoutForConsole(key);
  const consoleSrc = key ? consoleImageUrl(key, manifest) : null;
  const cartSrc = game ? cartImageForGame(game) : null;
  const label = game ? game.title : key ? consoleLabel(key) : 'Escolhe um jogo';

  return (
    <aside className="console-cart-preview" aria-live="polite">
      <p className="console-cart-preview__label">{label}</p>
      <div
        className={`console-cart-preview__stage console-cart-preview--${key || 'empty'} console-cart-preview--${phase}`}
        style={{
          '--cart-insert-y': layout.insertY,
          '--cart-width': layout.cartWidth,
          '--slot-glow-at': layout.slotGlow,
        }}
      >
        {consoleSrc ? (
          <img className="console-cart-preview__console" src={consoleSrc} alt="" draggable={false} />
        ) : (
          <div className="console-cart-preview__console console-cart-preview__console--placeholder" aria-hidden="true" />
        )}

        <div className="console-cart-preview__slot-glow" aria-hidden="true" />

        {cartSrc && game ? (
          <img
            key={game.id}
            className="console-cart-preview__cart"
            src={cartSrc}
            alt=""
            draggable={false}
          />
        ) : (
          <div className="console-cart-preview__cart console-cart-preview__cart--empty" aria-hidden="true">
            ?
          </div>
        )}
      </div>
      {game?.year ? <p className="console-cart-preview__meta">{game.year}</p> : null}
    </aside>
  );
}
